import React from 'react';
import { motion } from 'framer-motion';
import { AlertOctagon, HeartPulse, Leaf, Shield, Zap } from 'lucide-react';
export function ProblemSolution() {
  return <section className="py-12 md:py-16 px-4 bg-cream" data-id="element-132">
      <div className="max-w-4xl mx-auto" data-id="element-133">
        {/* Problem Section */}
        <div className="mb-14 md:mb-16" data-id="element-134">
          <div className="text-center mb-8 md:mb-10" data-id="element-135">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-primary mb-4" data-id="element-136">
              La verdad oculta sobre el alimento balanceado
            </h2>
            <p className="text-lg text-brown-light max-w-2xl mx-auto" data-id="element-137">
              Nos hicieron creer que las "croquetas" son lo mejor para ellos,
              pero la realidad es muy diferente.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-138">
            {[{
            title: 'Ingredientes de baja calidad',
            desc: 'Restos de matadero, picos, plumas y harinas que no aportan valor nutricional real.'
          }, {
            title: 'Exceso de carbohidratos',
            desc: 'Maíz y trigo que los perros no procesan bien, causando obesidad y diabetes.'
          }, {
            title: 'Conservantes químicos',
            desc: 'Tóxicos que a largo plazo generan tumores y problemas hepáticos.'
          }, {
            title: 'El origen de las alergias',
            desc: 'La principal causa de picazón constante, caída de pelo y problemas digestivos.'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white p-6 rounded-2xl shadow-sm border border-cream-dark flex gap-4" data-id="element-139">
                <div className="flex-shrink-0 mt-1" data-id="element-140">
                  <AlertOctagon className="text-accent" size={24} data-id="element-141" />
                </div>
                <div data-id="element-142">
                  <h3 className="font-bold text-primary text-lg mb-2" data-id="element-143">
                    {item.title}
                  </h3>
                  <p className="text-brown-light text-sm leading-relaxed" data-id="element-144">
                    {item.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* Solution Section */}
        <div data-id="element-145">
          <div className="text-center mb-8 md:mb-10" data-id="element-146">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-primary mb-4" data-id="element-147">
              La naturaleza tiene la respuesta
            </h2>
            <p className="text-lg text-brown-light max-w-2xl mx-auto" data-id="element-148">
              Alimentar a tu perro con comida real, fresca y natural es el acto
              de amor más grande que podés hacer por su salud.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-149">
            {[{
            icon: HeartPulse,
            title: 'Más años de vida',
            desc: 'Aumentá su esperanza de vida hasta en un 30%.'
          }, {
            icon: Shield,
            title: 'Chau alergias',
            desc: 'Piel sana, sin picazón y un pelaje brillante.'
          }, {
            icon: Zap,
            title: 'Energía vital',
            desc: 'Notarás un cambio radical en su vitalidad diaria.'
          }, {
            icon: Leaf,
            title: 'Digestión perfecta',
            desc: 'Heces más pequeñas, firmes y sin mal olor.'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-primary text-center p-6 rounded-2xl text-cream" data-id="element-150">
                <div className="bg-primary-light w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-151">
                  <item.icon className="text-accent" size={24} data-id="element-152" />
                </div>
                <h3 className="font-bold text-lg mb-2" data-id="element-153">{item.title}</h3>
                <p className="text-sm text-cream-dark/80" data-id="element-154">{item.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}